import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLeaf, faWater, faTree, faRecycle, faGlobe } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom'; // For navigation
import saveEnvironmentImage from '../images/environment-mission.jpg';


const Environment: React.FC = () => {
  const navigate = useNavigate(); // Hook for navigation

  const handleDonateClick = () => {
    navigate('/donate');
  };

  return (
    <div className="environment-page">
      {/* Section 1: Hero Section with Background Image and Overlay */}
      <div className="hero-section" style={{ backgroundImage: `url('https://geniebook.com/cms/storage/app/uploads/public/647/713/e2c/647713e2cc1c8606432977.webp')` }}>
        <div className="overlay">
          <Container className="text-center py-5">
            <h1 className="hero-title">Protecting Our Planet</h1>
            <p className="hero-subtitle">Dedicated to sustainability, conservation, and building a greener future for all..</p>
            <Button className="mt-3 donate-btn" onClick={handleDonateClick}>
              Donate Us
            </Button>
          </Container>
        </div>
      </div>

      {/* Section 2: Our Mission */}
      <Container className="my-5">
        <Row className="align-items-center">
          <Col md={6}>
            <img
              src={saveEnvironmentImage}
              alt="Forest Conservation"
              className="img-fluid rounded shadow-lg"
            />
          </Col>
          <Col md={6}>
            <h2 className="section-title"><FontAwesomeIcon icon={faGlobe} className="me-2" /> Our Mission</h2>
            <p className="section-text">
              At Srisailam Foundation, we are committed to protecting the environment through reforestation, responsible waste management, and the promotion of renewable energy. Our mission is to build a sustainable and resilient future for generations to come.
            </p>
            <Button className="mt-3 donate-btn" onClick={handleDonateClick}>
              Donate Us
            </Button>
          </Col>
        </Row>
      </Container>

      {/* Section 3: Conservation Efforts */}
      <Container className="my-5 py-5" style={{ backgroundColor: '#F3F4F6' }}>
        <h2 className="text-center section-title mb-5"><FontAwesomeIcon icon={faLeaf} className="me-2" /> Conservation Efforts</h2>
        <Row className="g-4">
          <Col md={4}>
            <Card className="h-100 border-0 shadow-sm program-card">
              <Card.Img variant="top" src="https://terrapass.com/wp-content/uploads/2022/01/tree-reforestation-plan-two-people-planting-new-tree-photo.jpg" alt="Reforestation" />
              <Card.Body className="text-center">
                <Card.Title className="card-title">Reforestation</Card.Title>
                <Card.Text className="card-text">
                  Restoring ecosystems and fighting climate change by planting trees and reviving green cover.
                </Card.Text>
                <Button className="donate-btn" size="sm" onClick={handleDonateClick}>
                  Donate Us
                </Button>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="h-100 border-0 shadow-sm program-card">
              <Card.Img variant="top" src="https://images.prismic.io/palmettoblog/54e8a326-b554-4a44-9d95-d8de7bbea1a8_water-conservation-tips.jpg?auto=compress,format&rect=0,0,1200,800&w=1200&h=800" alt="Water Conservation" />
              <Card.Body className="text-center">
                <Card.Title className="card-title">Water Conservation</Card.Title>
                <Card.Text className="card-text">
                  Preserving water resources through sustainable practices and innovative irrigation solutions.
                </Card.Text>
                <Button className="donate-btn" size="sm" onClick={handleDonateClick}>
                  Donate Us
                </Button>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="h-100 border-0 shadow-sm program-card">
              <Card.Img variant="top" src="https://thumbs.dreamstime.com/b/save-earth-concept-illustration-variety-wild-animals-surrounding-perimeter-globe-planet-interspersed-41860191.jpg" alt="Wildlife Protection" />
              <Card.Body className="text-center">
                <Card.Title className="card-title">Wildlife Protection</Card.Title>
                <Card.Text className="card-text">
                  Safeguarding endangered species and preserving their natural habitats for ecological balance.
                </Card.Text>
                <Button className="donate-btn" size="sm" onClick={handleDonateClick}>
                  Donate Us
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* Section 4: Sustainability Initiatives */}
      <Container className="my-5">
        <Row className="align-items-center flex-row-reverse">
          <Col md={6}>
            <img
              src="https://i.pinimg.com/736x/83/82/a8/8382a8d569f09e86e25ed5d829af0775.jpg"
              alt="Solar Energy"
              className="img-fluid "
            />
          </Col>
          <Col md={6}>
            <h2 className="section-title"><FontAwesomeIcon icon={faRecycle} className="me-2" /> Sustainability Initiatives</h2>
            <p className="section-text">
              Promoting renewable energy, waste recycling, and eco-friendly practices to reduce our carbon footprint and create a greener, more sustainable future.
            </p>
            <Button className="mt-3 donate-btn" onClick={handleDonateClick}>
              Donate Us
            </Button>
          </Col>
        </Row>
      </Container>

      {/* Section 5: Community Involvement */}
      <Container className="my-5 py-5" style={{ backgroundColor: '#E5E7EB' }}>
        <h2 className="text-center section-title mb-5"><FontAwesomeIcon icon={faTree} className="me-2" /> Community Involvement</h2>
        <Row className="g-4">
          <Col md={6}>
            <Card className="h-100 border-0 shadow-sm program-card">
              <Card.Img variant="top" src="https://i.pinimg.com/736x/66/ee/2a/66ee2ada8f35ca1a2efa86bf1ef84d65.jpg" alt="Community Cleanup" />
              <Card.Body className="text-center">
                <Card.Title className="card-title">Cleanup Drives</Card.Title>
                <Card.Text className="card-text">
                  Mobilizing communities through regular clean-up campaigns to maintain a pristine and healthy environment.
                </Card.Text>
                <Button className="donate-btn" size="sm" onClick={handleDonateClick}>
                  Donate Us
                </Button>
              </Card.Body>
            </Card>
          </Col>
          <Col md={6}>
            <Card className="h-100 border-0 shadow-sm program-card">
              <Card.Img variant="top" src="https://i.pinimg.com/736x/59/30/c1/5930c1f46dd65e9fc274b1d3eb2a8b08.jpg" alt="Awareness Campaigns" />
              <Card.Body className="text-center">
                <Card.Title className="card-title">Awareness Campaigns</Card.Title>
                <Card.Text className="card-text">
                  Raising awareness on environmental conservation and promoting sustainable living practices for a healthier planet.
                </Card.Text>
                <Button className="donate-btn" size="sm" onClick={handleDonateClick}>
                  Donate Us
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* Section 6: Call to Action */}
      <Container className="my-5 text-center py-5" style={{ backgroundColor: 'grey', color: '#FFFFFF' }}>
        <h2 className="section-title mb-4" style={{ color: '#FFFFFF' }}>Join the Green Revolution</h2>
        <p className="section-text mb-4" style={{ color: '#FFFFFF' }}>
          Your support is crucial in protecting the environment and securing a sustainable future. Take action today!
        </p>
        <Button className="donate-btn" size="lg" onClick={handleDonateClick}>
          Donate Us
        </Button>
      </Container>
    </div>
  );
};

export default Environment;
